<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">
                <div class="card-title">Employee Branch/Site</div>
            </div>
            <div class="col-md-4">
                <ng-select name="branch" [items]="WorkStatus" bindLabel="WorkStatusName" bindValue="WorkStatusName"
                    [(ngModel)]="WorkStatuValues" placeholder="All Working Status">
                </ng-select>
            </div>
            <div class="col-md-auto">
                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled" (click)="FilterStatusWise()">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Apply':'Loading...'}}</button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">
                        <div style="width:75px"><input class="form-check-input" type="checkbox" id="IsCheckAll"
                                name="IsCheckAll" (click)="selectAll($event,true)"> Check All
                            <br />
                            <input class="form-check-input" type="checkbox" id="IsCheckAll" name="IsCheckAll"
                                (click)="selectAll($event,false)"> Check
                        </div>
                    </th>
                    <th style="width: 5px">IsSync</th>
                    <th style="width: 100px">Working Status</th>
                    <th style="width: 300px;">Details</th>
                    <th style="width: 50px">Code Type</th>
                    <th style="width: 50px">Branch/Site Code</th>
                    <th style="width: 100px">Serial Number</th>
                    <th style="width: 5px">IsFace</th>
                    <th style="width: 5px">IsCard</th>
                    <th style="width: 100px">Card No</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Data; let i = index">
                    <td style="width: 5px">
                        <input type="checkbox" [(ngModel)]="element['selected']" name="check{{i}}">
                    </td>
                    <td style="width: 5px" class="text-center">
                        <span *ngIf="element['IsSync']" class="badge success">Yes</span>
                        <span *ngIf="!element['IsSync']" class="badge warning">No</span>
                    </td>
                    <td style="width: 100px">
                        <div style="width: 100px"><span class="badge"
                                [ngClass]="{'danger': this.common.ToLowerCase(element['EmployeeStatus']) == 'left','view': this.common.ToLowerCase(element['EmployeeStatus']) != 'left'}">{{element['EmployeeStatus']}}</span>
                        </div>
                    </td>
                    <td style="width: 300px;">
                        <div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="element['Image'] != null && element['Image'] != ''"
                                    (click)="common.FullImage('',{ProfileImage:element['Image'],Name:element['FullName'],Code:element['EmpCode']} )"
                                    mat-card-image class="userImage" [src]="element['Image']" />
                                <div *ngIf="element['Image'] == null || element['Image'] == ''"
                                    (click)="common.FullImage('',{ProfileImage:element['Image'],Name:element['FullName'],Code:element['EmpCode']} )"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(element['FullName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-10">
                                <span class="text-label">{{element['FullName']}}</span><br />
                                <span class="text-label-light">#{{element['EmpCode']}} <span
                                        *ngIf="element['DesignationName'] != null && element['DesignationName'] != ''">[{{element['DesignationName']}}]</span></span><br />
                            </div>
                        </div>
                    </td>
                    <td style="width: 50px">
                        <div style="width: 50px">{{element['CodeType']}}</div>
                    </td>
                    <td style="width: 50px">
                        <div style="width: 50px">{{element['BranchSiteCode']}}</div>
                    </td>
                    <td style="width: 100px">
                        <div style="width: 100px">{{element['DeviceSerialNumber']}}</div>
                    </td>
                    <td style="width: 5px">
                        {{element['IsFace']?'Yes':'No'}}
                    </td>
                    <td style="width: 5px">
                        {{element['IsCard']?'Yes':'No'}}
                    </td>
                    <td style="width: 100px">
                        <div style="width: 100px">{{element['CardNo']}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer" *ngIf="Data.length > 0 && this.common.PageRight.IsView">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary mx-1" [disabled]="isDisabled"
                    [routerLink]="['/attendancedevice/sitebranchmapping']"><i class="bi bi-arrow-left"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="button" class="btn btn-danger mx-1" [disabled]="isDisabled" (click)="UnSyncWithDevice()"
                    disabled><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Unsync With Device':'Loading...'}}</button>

                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled" (click)="SyncWithDevice()"><i
                        class="bi bi-check2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Sync With Device':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>